import Axios from 'axios';
import AxiosConfig from 'src/utilities/AxiosConfig';
import { DropdownOption, StateResponse } from '../DailyReviewInterfaces';

const getStatesForDropdown = async () => {
    try {
        const response : any = await Axios.get(`${process.env.REACT_APP_API_URL}/api/DailyReview/GetStatesForDropdown`, AxiosConfig.configValue('min'));
        const options : DropdownOption[] = [];
        response.data.response.map((item : StateResponse) => {
            const stateOption : DropdownOption = {
                label: item.StateName,
                id: item.StateID
            };
            options.push(stateOption);
        });

        return { success: true, response: options }
    } catch (error) {
        return { success: false, resposne: error }
    }
};

export default getStatesForDropdown;